import Link from "next/link";

import ExpandableContainer from "components/botanic/ExpandableContainer";

type Props = {
  text: string;
  title: string;
  itemUrl: string;
  createdDate: string;
  isPrivate: boolean;
  reportedFeelings?: string[];
};

const ReviewCard = ({
  text,
  title,
  itemUrl,
  createdDate,
  isPrivate,
  reportedFeelings,
}: Props) => {
  const date = createdDate && new Date(createdDate);

  return (
    <article className="h-full shadow-low rounded flex flex-col justify-between">
      <div className="p-lg">
        <h3>
          <Link className="underline" href={itemUrl}>
            {title}
          </Link>
        </h3>
        <div className="text-xs mb-md">
          {`${date ? date.toLocaleDateString() : ""}${
            date && isPrivate ? " | " : ""
          }${isPrivate ? "Private" : ""}`}
        </div>
        <ExpandableContainer initialHeight="192px">{text}</ExpandableContainer>
      </div>
      {reportedFeelings?.length ? (
        <footer className="bg-leafly-white flex p-sm flex items-center">
          <span className="mr-md font-bold text-xs">
            Reported <br />
            feelings
          </span>
          <span>
            {reportedFeelings.map((feeling: string) => (
              <span key={feeling} className="tag tag--outline my-xs mr-xs">
                {feeling}
              </span>
            ))}
          </span>
        </footer>
      ) : null}
    </article>
  );
};

export default ReviewCard;
